'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _effects = require('redux-saga/effects');

var _apiHelper = require('api/api-helper');

var _forms = require('utils/forms');

var _authTokenActions = require('actions/authTokenActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchAuthToken),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchAuthentication);

function fetchAuthToken(authParams) {
    var bookingId, customerId, apiClientKey, _ref, authTokenData, error, errors;

    return _regenerator2.default.wrap(function fetchAuthToken$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)(function (state) {
                        return state.booking.id;
                    });

                case 2:
                    bookingId = _context.sent;
                    _context.next = 5;
                    return (0, _effects.select)(function (state) {
                        return state.user.customerId;
                    });

                case 5:
                    customerId = _context.sent;
                    _context.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.user.apiClientKey;
                    });

                case 8:
                    apiClientKey = _context.sent;
                    _context.next = 11;
                    return (0, _effects.call)(_apiHelper.getAuthToken, (0, _extends3.default)({}, authParams, { bookingId: bookingId, customerId: customerId, apiClientKey: apiClientKey }));

                case 11:
                    _ref = _context.sent;
                    authTokenData = _ref.authTokenData;
                    error = _ref.error;

                    if (!error) {
                        _context.next = 20;
                        break;
                    }

                    errors = (0, _forms.updateErrorsObject)({ error: error, genErrorCode: 'AUTH_FAILED' });
                    _context.next = 18;
                    return (0, _effects.put)((0, _authTokenActions.authTokenRequestFailed)(errors));

                case 18:
                    _context.next = 22;
                    break;

                case 20:
                    _context.next = 22;
                    return (0, _effects.put)((0, _authTokenActions.authTokenReceived)(authTokenData.access_token));

                case 22:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function fetchAuthentication() {
    var _ref2, payload;

    return _regenerator2.default.wrap(function fetchAuthentication$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (!true) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return (0, _effects.take)(_authTokenActions.AUTH_TOKEN_REQUESTED);

                case 3:
                    _ref2 = _context2.sent;
                    payload = _ref2.payload;
                    _context2.next = 7;
                    return (0, _effects.fork)(fetchAuthToken, payload);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = fetchAuthentication;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchAuthentication.js
// module id = 1407
// module chunks = 0